import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Input, Form,FormInstance, Steps, notification} from "antd";

import { useTranslation } from "react-i18next";
import { sendEmailCode,resetPwdByEmail } from "../axios/api.account"
import "./pages.scss";

export function ForgetPwd() {
    const [isSent, setIsSent] = useState(false);  
    const [countdown, setCountdown] = useState(60); 
    const countRef = useRef(countdown);
    countRef.current = countdown;

    const [isSuccess, setIsSuccess] = useState(false);  
    const { t } = useTranslation();
    const formRef = React.createRef<FormInstance>();
    
    const sendCode = () => {
      // var email = formRef.current?.getFieldValue('email');
      // sendEmailCode(email,false).then(() => {  
      //   setIsSent(true);  
      //   startCountdown();
      // });
      formRef.current?.validateFields(['email']).then(res=>{
        setIsSent(true);
        startCountdown();
        sendEmailCode(res.email,false).then(() => {  
          
        },()=>{
          setIsSent(false);
        })
    });
    }; 

    const startCountdown = () => {  
      let intervalId = setInterval(() => {  
        if (countRef.current > 0) {  
          setCountdown(countdown=> countdown - 1);  
        } else {
          clearInterval(intervalId);  
          setIsSent(false);  
          setCountdown(countdown=> countdown + 60);  
        }  
      }, 1000);
      // 在组件卸载时清除倒计时，避免内存泄漏  
      return () => clearInterval(intervalId);  
    };  

    function resetPwd(){
      formRef?.current?.validateFields().then(res=>{
        console.log(res);
        resetPwdByEmail(res).then(() => {  
          setIsSuccess(true);
        }); 
      })
    }

    // useEffect(() => {  
    //   return () => {  
    //     if (isSent) {  
    //       startCountdown();  
    //     }  
    //   };  
    // }, [isSent]);

    return (
      <div className="login-container" style={{backgroundImage: "url(images/bg.png)"}}>  
        <div className="logo-container">  
          {/* 这里应该放置TAPD的Logo */}  
          <h1>{t("未瓴移动设备管理平台")}</h1>
        </div>
        <div className="mx-auto" style={{ marginTop: "50px",width:'40%' }}>
          <div style={{ }}>
            {!isSuccess && <Form
              ref={formRef}
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 16 }}
              //style={{ maxWidth: 600 }}
              autoComplete="off"
              >
                <Form.Item
                  label={t("邮箱")}
                  name="email"
                  rules={[{ required: true, message: t("请输入邮箱") },
                  {
                    type: 'email',
                    message: t('邮箱格式错误')
                  }]}
                >
                <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                  label={t("验证码")}
                  name="code"
                  rules={[{ required: true, message: t('请输入验证码') }]}
                >
                  <Row>
                    <Col span={12}>
                      <Input />
                    </Col>
                    <Col span={12}>
                      <Button disabled={isSent} onClick={isSent ? undefined : sendCode}>  
                        {isSent ? t('重新发送') + `(${countdown}s)` : t('发送验证码')}  
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item
                  label={t("密码")}
                  name="password"
                  rules={[
                    { 
                      required: true, 
                      message: t('请输入密码')
                    },
                    {
                        // pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$'),
                        pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[~`·!@#$%^&*()<>?,.:;_+/、，。：；？！（）【】《》-]).{8,}$'),
                        message: t('密码必须包含大小写字母和特殊字符，且长度至少为8'),
                        //message: 'Password must contain at least one lowercase, one uppercase, and one special character, and be at least 8 characters long.',
                    }
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="confirm"
                  label={t("密码确认")}
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: '请确认您的密码!',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('两次输入的密码不匹配!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                  <Button type="primary" onClick={() => { resetPwd(); } } className="login-form-button" htmlType="submit">
                    {t("提交")}
                  </Button>
                </Form.Item>
              </Form>
              }
              {isSuccess &&(
              <><Row>
                  <Col span={18} offset={6}>
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      <p>已完成密码重置，点击<a href="/login">登录</a>跳转到登录页</p>
                    </span>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </div>
      </div> 
    )
}